import Vue from 'vue'
import Vuex from 'vuex'

import themes from './modules/themes'
import profile from './modules/profile'
import optionchain from './modules/optionchain'
import orderTicket from './modules/orderTicket'
import sod from './modules/sod'
import grouptrade from './modules/grouptrade'
import onboarding from './modules/onboarding'
import snackbar from './modules/snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    themes,
    profile,
    optionchain,
    orderTicket,
    sod,
    grouptrade,
    onboarding,
    snackbar,
  },
})
